import React, { memo } from 'react'

import { Icon, User } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DesignerContent from 'Pods/SearchPage/Shared/DesignerContent/DesignerContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const prefixIcon = <Icon notSpaced svgComponent={User} color="dark" size="small" />
const content = <DesignerContent />

function Designers() {
  const translate = useTranslate()

  const designers = useSearchPageStore(state => state.designers ?? EMPTY_ARRAY)
  const scopes = useSearchPageStore(state => state.designerScopes ?? EMPTY_ARRAY)

  // Reset lives inside DesignerContent, which is the only place that can resolve a scope flag back
  // into a designer count. The trigger only needs to know whether anything is on at all.
  const hasSelectedAnyFilter = designers.length > 0 || scopes.length > 0

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.designers.title')}
      prefixIcon={prefixIcon}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      closingDropdownClassName="filter-wrapper"
      contentClassName="designer-filter__popover-content"
    />
  )
}

export default memo(Designers)
